<template>
  <div>
    <el-tabs v-model="activeName">
      <el-tab-pane name="LossLegalHousePlan" label="欠费明细">
        <template slot="label">
          <span>
            欠费明细
            <el-badge :value="legal_house_obj.total" ></el-badge>
          </span>
        </template>
        <LossLegalHousePlan @onAdd="handleAdd" v-if="activeName==='LossLegalHousePlan'" />
      </el-tab-pane>
      <el-tab-pane name="LegalHousePlanTemp" label="当期计划">
        <template slot="label">
          <span>
            当期计划
            <el-badge :value="legal_house_obj.count_obj['当期']" ></el-badge>
          </span>
        </template>
        <LegalHousePlanTempExcel @onAdd="handleAdd" v-if="activeName==='LegalHousePlanTemp'" :age_type_ids="[1]" :is_show_flow="true" :is_show_sync="true" />
      </el-tab-pane>
      <el-tab-pane name="LegalHousePlanTemp2" label="历史计划">
        <template slot="label">
          <span>
            纯上1年
            <el-badge :value="(legal_house_obj.count_obj['纯上1年'])" ></el-badge>
          </span>
        </template>
        <LegalHousePlanTempExcel @onAdd="handleAdd" v-if="activeName==='LegalHousePlanTemp2'" :age_type_ids="[2]" :is_show_flow="true" :is_show_sync="true" />
      </el-tab-pane>
      <el-tab-pane name="LegalHousePlanTemp3" label="当期+纯上1年">
        <template slot="label">
          <span>
            发起流程
            <el-badge :value="(legal_house_obj.count_obj['当期']+legal_house_obj.count_obj['纯上1年'])" ></el-badge>
          </span>
        </template>
        <LegalHousePlanTempExcel @onAdd="handleAdd" v-if="activeName==='LegalHousePlanTemp3'" :age_type_ids="[1,2]" :is_show_flow="true" :is_show_sync="true" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import LossLegalHousePlan from "./LossLegalHousePlan";
import LegalHousePlanTemp from "./LegalHousePlanTemp";
import LegalHousePlanTempExcel from "./LegalHousePlanTempExcel";
import ButlerHttp from "../../common/ButlerHttp";
import {CommonHelp} from "../../common/CommonHelp";
export default {
  name: "LossLegalHoseLayout",
  inject:['where','reginWhere'],
  components: {LegalHousePlanTempExcel,LegalHousePlanTemp, LossLegalHousePlan},
  data() {
    return {
      activeName: "LossLegalHousePlan",
      legal_house_obj: {
        total: 0,
        total2: 0,
        count: 0,
        count2: 0,
        count_obj: {
          '当期': 0,
          '纯上1年': 0,
          '1年以上2年以内': 0,
          '2年以上': 0,
        }
      },
    };
  },
  mounted() {
    this.handleAdd();
  },
  methods: {
    handleAdd(){
      const that = this;
      let where = {
        project_ids:typeof that.reginWhere.project_ids==="string"?that.reginWhere.project_ids:'',
        project_id:that.reginWhere.project_name,
        area_id:that.reginWhere.area_id
      }
      ButlerHttp.post("HouseUrgeTempLog/getLegalHouseCount",where,res=>{
        console.log(res.data)
        res.data.count_obj['当期'] = (res.data.count_obj['当期'] || 0)*1;
        res.data.count_obj['纯上1年'] = (res.data.count_obj['纯上1年'] || 0)*1;
        res.data.count_obj['1年以上2年以内'] = (res.data.count_obj['1年以上2年以内'] || 0)*1;
        res.data.count_obj['2年以上'] = (res.data.count_obj['2年以上'] || 0)*1;
        that.legal_house_obj = res.data;
      })
    }
  },
  watch:{
    "reginWhere.type_id":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.handleAdd();
      },500,that);
    },
    "reginWhere.project_region":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.handleAdd();
      },500,that);
    },
    "reginWhere.project_name":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.handleAdd();
      },500,that);
    },
    "reginWhere.area_id":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.handleAdd();
      },500,that);
    },
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Admin/Butler/components/plan/LossLegalHoseLayout.vue